<template>
  <div id="userAccountSet">

    <mt-header title="账号设置" style="height: 50px">
      <router-link to="/mine" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <div class="userAccountSet-cell" @click="goUserInfoEvent()">
      <div class="userAccountSet-cell-leftTitle">个人信息</div>
      <div class="userAccountSet-cell-rightView">
        <img :src="userIcon" id="userAccountSet-userIcon"/>
        <img src="../../../assets/icon/continue.png" style="width: 7px;height: auto;vertical-align: 60%"/>
      </div>
    </div>
    <hr class="userAccountSet-sparator"/>
    <router-link to="">

    </router-link>


    <div class="userAccountSet-cell">
      <div class="userAccountSet-cell-leftTitle">账号绑定</div>

      <div class="userAccountSet-cell-rightView" v-if="isBindMobile === true">
        {{mobile}}
      </div>

      <router-link :to="{ path: '/userAccountSet/bindMobilePhone', query: { url: '/userAccountSet' }}" v-if="isBindMobile === false">
        <div class="userAccountSet-cell-rightView" >

          <span id="userAccountSet-unbind">未绑定</span>
          <img src="../../../assets/icon/continue.png" style="width: 7px;height: auto"/>
        </div>
      </router-link>


    </div>
    <hr class="userAccountSet-sparator"/>

    <!--<router-link :to="{ path: '/resetPassword', query: { type: type }}" >-->
      <div class="userAccountSet-cell" v-if="isBindMobile === true" @click="gotoResetPswEvent()">

        <!--<router-link to="{ path: '/resetPassword', query: { type: 'resetpassowrd' }}" >-->

          <div class="userAccountSet-cell-leftTitle">{{showSetPasswordText}}</div>
          <div class="userAccountSet-cell-rightView">
            <img src="../../../assets/icon/continue.png" style="width: 7px;height: auto"/>
          </div>


      </div>
    <!--</router-link>-->
    <hr class="userAccountSet-sparator" v-if="isBindMobile === true"/>

    <div class="logout" @click="logout" v-if="isShowLogout">
      <hr class="sparator2"/>
      <div>退出登录</div>
    </div>
  </div>


</template>

<script>
  import api from '../../../api/common/api.common'

  export default {
    computed: {
      type () {
        if (this.$store.state.user.initPassword === true) {
          return 'editPassword'
        }
        else {
          return 'resetpassowrd'
        }
      },
      isShowLogout () {

        if (this.utils.isWxLogin()) {
          return false
        }
        return true
      }
    },
    data () {
      return {
        isBindMobile: false,
        mobile: '',
        userIcon: '',
        showSetPasswordText: '设置密码'
      }
    },
    mounted () {
      var self = this
      self.isBindMobile = self.$store.state.user['userId'] !== undefined
      this.mobile = this.$store.state.user['mobilePhone']
      this.userIcon = this.$store.state.user.avatar
      if (this.$store.state.user.initPassword === true) {
        this.showSetPasswordText = '修改密码'
      } else {
        this.showSetPasswordText = '设置密码'
      }

      api.getUserInfo({},function (successRsp) {
        self.$store.dispatch('setUserLogin',successRsp.body.data)
        self.isBindMobile = self.$store.state.user['userId'] !== undefined
        if (self.$store.state.user['mobilePhone'] !== undefined) {
          self.mobile = self.$store.state.user['mobilePhone']
        }
        self.userIcon = self.$store.state.user.avatar
      },function () {

      },false)
    },
    methods: {
      gotoResetPswEvent () {
        this.$router.replace({ path: '/resetPassword', query: { type: this.type }})
      },
      goUserInfoEvent () {
        if (this.isBindMobile === true) {
          this.$router.push('/userAccountSet/info')
        } else {
          this.$router.push({ path: '/userAccountSet/bindMobilePhone', query: { url: '/userAccountSet' }})

        }
      },
      logout () {
        var self = this
        api.logout({},function (respond) {
          console.log(respond)
          localStorage.setItem('userIsLogin', false)
          localStorage.setItem('isWxLogin-cache', false)
          localStorage.setItem('loginCredentials', null)
          self.utils.alert('退出成功')
          self.$router.push('/')
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  .userAccountSet-cell {
    font-size: pxToRem(24px);
    margin-left: pxToRem(50px);
    margin-right: 0px;
    height: pxToRem(122px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*line-height: pxToRem(135px);*/
  }

  #userAccountSet-unbind {
    font-size: pxToRem(24px);
    margin-right: pxToRem(20px);
    color: #191919;
    margin-top: 0px;
    margin-bottom: 0px;
    /*background-color: #26a2ff;*/
    vertical-align: text-top;

  }
  .userAccountSet-cell-leftTitle {
    color: #BDBDBD;
    display: inline-block;
    height: pxToRem(122px);
    line-height: pxToRem(122px);

  }

  .userAccountSet-cell-rightView {
    margin-right: pxToRem(52px);
    font-size: pxToRem(24px);
    text-align: right;
    height: pxToRem(122px);
    align-items: center;
    display: flex;

  }

  .userAccountSet-sparator {
    height: 1px;
    background-color: #d8d8d8;
    margin-left: pxToRem(50px);

  }

  #userAccountSet-userIcon {
    width: pxToRem(70px);
    height: pxToRem(70px);
    background: #EEEEEE;
    -moz-border-radius: pxToRem(35px);
    -webkit-border-radius: pxToRem(35px);
    border-radius: pxToRem(35px);

    border-width: 0px;
    margin-right: pxToRem(20px);
    border-color: #000 #000 #000 #000;
  }

  .logout {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: pxToRem(110px);
    color: #191919;
    font-size: pxToRem(28px);

    background-color: white;

    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sparator2 {
    height: 1px;
    background-color: #d8d8d8;
    position: absolute;

    top:0px;
    left:0;
    right:0;
  }
</style>


// WEBPACK FOOTER //
// userAccountSet.vue?45170ae3